import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {selectKP11SelectCartCentersNApps} from '../../../../../../app-store/kp11CartSlice'
import {
  CardPlanBodyStyle,
  CardPlanAddToCartStyle,
  CardPlanWebsiteUrlStyle,
} from '../kp-11Link-catalog-cards-style'
import {kpSuccessIcon} from '../../../../../../assets'
import {PlanRadioInput} from '../../../kp-11Link-reusable-components/kp-plan-radio-input'
import {CardPlanItemWrapStyle} from '../../../kp-11Link-reusable-components/kp-plan-radio-input-style'
import {
  buildCartEntity,
  getItemFromCart,
} from '../../../kp-11Link-utility/kp11-utility'
import {DELAY_HIDE_IN_SEC} from '../../../../../../utils/constants'
import VerticalServicePaymentQuestion from './vertical-service-payment-question'

export const KP11LinkHomeservicesCardComponent = ({
  groupKey,
  items = [],
  onSelectItem,
  disabled,
  addedToCart,
  onGroupCustomFieldsUpdate,
  selectedCountry = 'US',
}) => {
  // Get selectedItem from Redux
  const reduxCartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const [paymentOption, setPaymentOption] = useState('')
  // const selectedItem =
  const selectedItemFromCart = getItemFromCart({
    reduxCartCentersAndApps,
    groupKey,
    items,
  })
  const [selectedItem, setSelectedItem] = useState(null)
  const [add2CartBannerStatus, setAdd2BannerStatus] = useState(addedToCart)
  const isInCart = Boolean(selectedItemFromCart?.code)
  const isSaveButtonDisabled = !paymentOption || !selectedItem || isInCart
  useEffect(() => {
    if (addedToCart) {
      setAdd2BannerStatus(true)
      setTimeout(() => {
        setAdd2BannerStatus(false)
      }, DELAY_HIDE_IN_SEC * 1000)
    }
  }, [addedToCart])

  useEffect(() => {
    const homeServicesPaymentOption = {paymentOption: paymentOption}
    onGroupCustomFieldsUpdate(homeServicesPaymentOption)
  }, [paymentOption])

  useEffect(() => {
    if (selectedItemFromCart?.code) {
      setSelectedItem(selectedItemFromCart)
    }
  }, [selectedItemFromCart?.code])

  const isPlanDisabled = (disabled, item) => {
    const isItemAllreadyAdded = item?.isAlreadyAdded
    const isdisabled =
      disabled || isItemAllreadyAdded || !paymentOption || isInCart
    return isdisabled
  }
  // --- Determine checked and disabled state ---
  const getItemState = item => {
    const selectedCode = selectedItemFromCart?.code || selectedItem?.code

    // Default case
    return {checked: selectedCode === item.code, disabled: false}
  }

  const saveButtonHandler = e => {
    e.stopPropagation()

    if (isSaveButtonDisabled) {
      return
    }

    const updatedItem = buildCartEntity({
      kind: 'item',
      source: selectedItem,
      customFields: {paymentOption: paymentOption},
      selectCentersAndApps: reduxCartCentersAndApps,
    })
    onSelectItem(updatedItem)
  }

  return (
    <CardPlanBodyStyle>
      <CardPlanWebsiteUrlStyle>
        <VerticalServicePaymentQuestion
          selectedOption={paymentOption}
          setSelectedOption={setPaymentOption}
        />
      </CardPlanWebsiteUrlStyle>
      <CardPlanItemWrapStyle wrap>
        {items.map(item => {
          const {checked} = getItemState(item)
          return (
            <PlanRadioInput
              key={item.code}
              item={item}
              checked={checked}
              disabled={isPlanDisabled(disabled, item)}
              onChange={() => setSelectedItem(item)}
              country={selectedCountry}
            />
          )
        })}
        <button
          type="button"
          style={{
            marginTop: '1rem',
            marginLeft: 'auto',
            display: 'block',
            backgroundColor: isSaveButtonDisabled ? '#ccc' : '#FF6100',
            border: 'none',
            color: isSaveButtonDisabled ? '#888' : 'white',
            padding: '0.2rem 0.5rem',
            borderRadius: '0.5px',
            fontWeight: 'bold',
            width: '35%',
            opacity: isSaveButtonDisabled ? 0.7 : 1,
            transition: 'background-color 0.2s',
          }}
          onClick={e => saveButtonHandler(e)}
          disabled={isSaveButtonDisabled}
        >
          Add to Cart
        </button>
      </CardPlanItemWrapStyle>

      {add2CartBannerStatus && (
        <CardPlanAddToCartStyle>
          <img src={kpSuccessIcon} alt="success icon" />
          <span>Added to cart</span>
        </CardPlanAddToCartStyle>
      )}
    </CardPlanBodyStyle>
  )
}
